// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 224) return "static/chunks/224-d35ea4e2fea6a156.js";
	if (chunkId === 791) return "static/chunks/791-ff58835f9150a988.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 372 ? "e0acaca8" : chunkId) + "." + {"372":"318b6840206899c4","542":"9102c1153dab2add","549":"22ec593b34356576","669":"0e34f823c2f02b4d","783":"f8ba34073c4b8304","980":"257dded9bf6e8d9e"}[chunkId] + ".js";
};